import { FormControl, ValidatorFn } from '@angular/forms';
import { IGenericBaryFormGroup } from '../GenericBaryFormGroup';
import { ThemeView } from '../../theme-view.model';
import { IFormBuilder } from '../IFormBuilder';
import { BaryFormFactoryService } from '../../../services/bary-form-factory.service';
import { ThemeFormGroup } from '../ThemeFormGroup';

interface IThemeFormBuilder extends IFormBuilder<ThemeControls> {
  init(themeView: ThemeView): IThemeFormBuilder;

  build(): IGenericBaryFormGroup<ThemeControls>;
}

export type ThemeControls = {
  id: FormControl;
  activated: FormControl;
  transporter: FormControl;
};

export class ThemeFormBuilder implements IThemeFormBuilder {
  private formName = 'themeForm';
  private controls!: ThemeControls;
  private validators?: ValidatorFn[];

  constructor(private bcf: BaryFormFactoryService) {}

  init(themeView?: ThemeView): ThemeFormBuilder {
    this.controls = this.bcf.makeThemeControls(themeView);
    return this;
  }

  build(): ThemeFormGroup {
    return new ThemeFormGroup(this.formName, this.controls, this.validators);
  }
}
